document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.toggle-section > *:first-child').forEach(function(header) {
        header.addEventListener('click', function() {
            const section = this.parentElement;

            document.querySelectorAll('.toggle-section').forEach(function(otherSection) {
                if (otherSection !== section) {
                    otherSection.classList.remove('expanded');
                }
            });

            section.classList.toggle('expanded');
        });
    });

    const firstSection = document.querySelector('.toggle-section');
    if (firstSection) {
        firstSection.classList.add('expanded');
    }
});
